/* eslint-disable */
// sdk埋点
export const sensorsUrl = `http://ut.klicen.com/logcollect/collect/client`;
export const sensorsDvoUrl = `http://galaxy.dev.iklicen.com/logcollect/collect/client`;
export const sensorsTestUrl = `http://galaxy.test.iklicen.com/logcollect/collect/client`;
export const sensorsPreUrl = `http://galaxy2.pre.klicen.com/logcollect/collect/client`;
export const sensorsUatUrl = `http://galaxy.uat.iklicen.com/logcollect/collect/client`;

// 凯励程CRM APP下载
export const gaiaApp = `http://xyt-gaia-public.klicen.com/static/gaia_app_download.png`;
// 凯励程CRM微信绑定
export const gaiaWechat = `http://xyt-gaia-public.klicen.com/static/gaia_wechat_mp.jpg`;

// 业务订单导入-保养订单导入上传模板
export const orderUrl = `https://xyt-gaia.oss-cn-beijing.aliyuncs.com/template/保养订单导入模板.xlsx`;

// 优惠券/创建活动-车架号\创建活动-手机号上\基盘导入-客户导入等上传模板
export const klicenUrl = value => `https://xyt-gaia-public.klicen.com/template/${value}.xlsx`;
